import { updateDialog } from '@Containers/Dialogs/DialogsActions';

import { typeOfAlertDeleteConfirmationDialog } from './AlertDeleteConfirmationDialogConstants';


export function open(id) {

  return updateDialog({
    id,
    alertId: id,
    dialogType: typeOfAlertDeleteConfirmationDialog,
  });
}
